// Names on a split: at least 2 characters, so "Q" or a stray tap doesn't become someone on the
// table. Shared by the server and the browser bundle, so both turn away the same names.

export const NAME_MIN = 2;
export const NAME_TOO_SHORT = 'Names need at least 2 letters.';

/** Characters, not UTF-16 units, so "Zoë" and an emoji count the way people see them. */
export const nameLength = (name: string): number => [...name.trim()].length;

/** True when a typed name is long enough. An empty name has its own message. */
export const nameLongEnough = (name: string): boolean => nameLength(name) >= NAME_MIN;
